import axios from 'axios';
import {
  activateAccountStart,
  activateAccountSuccess,
  activateAccountError,
  loginStart,
  loginSuccess,
  loginError,
  registerStart,
  registerSuccess,
  registerError,
  logout as logoutReducer,
  sendRecoverPasswordEmailStart,
  sendRecoverPasswordEmailSuccess,
  sendRecoverPasswordEmailError,
  verifyUserTokenStart,
  verifyUserTokenSuccess,
  verifyUserTokenError,
  recoverPasswordStart,
  recoverPasswordSuccess,
  recoverPasswordError
} from '../reducers/authReducer';
import { addNotification } from './notificationAction';

export const recoverPassword = (userToken, newPassword) => dispatch => {
  dispatch(recoverPasswordStart());
  axios
    .post('/api/backoffice/auth/recover-password', { userToken, newPassword })
    .then(() => {
      dispatch(recoverPasswordSuccess());
    })
    .catch(err => {
      dispatch(recoverPasswordError(err?.response?.data));
    });
};

export const verifyUserToken = userToken => dispatch => {
  dispatch(verifyUserTokenStart());
  axios
    .post('/api/backoffice/auth/verify-token', {
      userToken
    })
    .then(({ data }) => {
      if (data?.isValidDateToExpire) {
        dispatch(verifyUserTokenSuccess());
      } else {
        dispatch(verifyUserTokenError('Fecha de caducidad inválida'));
      }
    })
    .catch(err => {
      dispatch(verifyUserTokenError(err?.response?.data));
    });
};

export const sendRecoverPasswordEmail = email => dispatch => {
  dispatch(sendRecoverPasswordEmailStart());
  axios
    .post('/api/backoffice/auth/send-recover-password', {
      email
    })
    .then(() => {
      dispatch(sendRecoverPasswordEmailSuccess());
    })
    .catch(err => {
      dispatch(sendRecoverPasswordEmailError(err?.response?.data));
    });
};

export const activateAccount = userToken => dispatch => {
  dispatch(activateAccountStart());
  axios
    .post(`/api/app-mobile/auth/activate-account`, {
      userToken
    })
    .then(res => {
      const resData = res.data;
      dispatch(activateAccountSuccess(resData));
    })
    .catch(err => {
      dispatch(activateAccountError(err?.response?.data));
    });
};

export const login = (email, password) => dispatch => {
    dispatch(loginStart());

  let data = JSON.stringify({
    email,
    password
  });

  let config = {
    mode: 'no-cors',
    method: 'post',
    maxBodyLength: Infinity,
    url: '/api/backoffice/auth/login',
    withCredentials: false,
    headers: { 
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin':'*'
    },
    data : data
  };

  axios.request(config)
  .then(({ data }) => {
      const { accessToken, user } = data;
      localStorage.setItem('accessToken', accessToken);
      dispatch(loginSuccess(user));
      dispatch(addNotification('Bienvenid@! a alet', 'success'));
    })
  .catch(err => {
      const resError =
        err?.response?.data?.error || err?.message || 'Error desconocido';
      dispatch(addNotification(resError, 'error'));
      dispatch(loginError(resError));
    });

/*  axios
    .post('/api/backoffice/auth/login', data,{
	headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*"
	}
    } )
    .then(({ data }) => {
      const { accessToken, user } = data;
      localStorage.setItem('accessToken', accessToken);
      dispatch(loginSuccess(user));
      dispatch(addNotification('Bienvenid@! a alet', 'success'));
    })
    .catch(err => {
      const resError =
        err?.response?.data?.error || err?.message || 'Error desconocido';
      dispatch(addNotification(resError, 'error'));
      dispatch(loginError(resError));
    });*/
};

export const register = ({
  nombreRecinto,
  direccion,
  comuna,
  nombreAdmin,
  email,
  telefono,
  rutRecinto,
  password
}) => dispatch => {
  dispatch(registerStart());
  axios
    .post('/api/backoffice/auth/register', {
      nombreRecinto,
      direccion,
      comuna,
      nombreAdmin,
      email,
      telefono,
      rutRecinto,
      password
    })
    .then(() => {
      dispatch(registerSuccess());
      dispatch(addNotification('Registro exitoso!', 'success'));
    })
    .catch(err => {
      const resError =
        err?.response?.data?.error || err?.message || 'Error desconocido';
      dispatch(addNotification(resError, 'error'));
      dispatch(registerError(resError));
    });
};

export const logout = () => dispatch => {
  dispatch(logoutReducer());
  localStorage.removeItem('accessToken');
};
